module.exports = __webpack_public_path__ + "media/icons/volume_up-33bf0631.svg";